import { fulfilled } from 'lib/promiseMiddlewareHelpers'
import fetchJSON from 'lib/fetchJSON'
import { Set } from 'immutable'
import { getConsole } from 'lib/getConsole'
import _ from 'lodash'
const console = getConsole('rr', 'usersFollowed')

// Actions
export const FOLLOW_USER = 'usersFollowed/FOLLOW_USER'
export const UNFOLLOW_USER = 'usersFollowed/UNFOLLOW_USER'

const userIds = _.get(window, 'rwgps.config.rideReports.usersFollowed', [])
if (userIds === undefined) {
  console.error('missing required preload: rwgps.config.rideReports.usersFollowed')
}

const usersFollowedFromPreload = Set(userIds)

export const reducer = (state = usersFollowedFromPreload, action) => {
  switch (action.type) {
    case fulfilled(FOLLOW_USER): {
      const { userId } = action.meta
      return state.add(userId)
    }
    case fulfilled(UNFOLLOW_USER): {
      const { userId } = action.meta
      return state.remove(userId)
    }
    default:
      return state
  }
}

export const followUser = (userId) => ({
  type: FOLLOW_USER,
  payload: fetchJSON('/ride_reports/follow_user.json', { user_id: userId }),
  meta: { userId }
})

export const unfollowUser = (userId) => ({
  type: UNFOLLOW_USER,
  payload: fetchJSON('/ride_reports/unfollow_user.json', { user_id: userId }),
  meta: { userId }
})
